import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useEffect, useState } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import FormField from '@/shared/components/form/FormField';
import renderSelectField from '@/shared/components/form/Select';
import { CollectionCategoryEnum, BatchJobStorageEnum, BatchJobVCPUsEnum } from "Enums";
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const validate = (values) => {
    const errors = {};
    if (values.tiles_directory_uri && !values.tiles_directory_uri.startsWith('s3://')) 
        errors.tiles_directory_uri = 'Invalid S3 directory address';
    
    return errors;
};

const required = value => (value !== undefined ? undefined : 'Required')

const CreateTilesetAssets = () => {
    const [missions, setMissions] = useState();

    let collection_info = {
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json"
        ],
        "title": "{Constellation} {CollectionID}",
        "description": "HD aerial imagery collection of Canada. Maintained by FastMap",
        "license": "proprietary",
        "summaries": {
            "datetime": {},
            "platform": [],
            "constellation": [],
            "instruments": [],
            "view:off_nadir": {
                "minimum": 0,
                "maximum": 0
            },
            "view:sun_elevation": {
                "minimum": 0,
                "maximum": 0
            },
            "gsd": {
                "minimum": 0,
                "maximum": 0
            },
            "proj:epsg": [],
            "eo:cloud_cover": {
                "minimum": 0,
                "maximum": 0
            },
            "eo:bands": [
                {
                    "name": "band1",
                    "common_name": "red",
                    "center_wavelength": 625,
                    "full_width_half_max": 700
                },
                {
                    "name": "band2",
                    "common_name": "green",
                    "center_wavelength": 500,
                    "full_width_half_max": 565
                },
                {
                    "name": "band3",
                    "common_name": "blue",
                    "center_wavelength": 450,
                    "full_width_half_max": 485
                },
                {
                    "name": "band4",
                    "common_name": "alpha"
                }
            ]
        },
        "keywords": [
            "platform:manned",
            "platform:unmanned"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "description": "Spatial data library managed by FastMap.",
                "url": "https://fastmap.ai"
            }
        ]
    };

    let item_info = {
        "stac_version": "1.0.0",
        "stac_extensions": [
            "https://stac-extensions.github.io/eo/v1.0.0/schema.json",
            "https://stac-extensions.github.io/projection/v1.0.0/schema.json",
            "https://stac-extensions.github.io/view/v1.0.0/schema.json",
            "https://stac-extensions.github.io/processing/v1.0.0/schema.json",
            "https://stac-extensions.github.io/card4l/v1.0.0/optical/schema.json",
            "https://stac-extensions.github.io/web-map-links/v1.2.0/schema.json"
        ],
        "providers": [
            {
                "name": "FastMap Inc.",
                "description": "Add company description here",
                "roles": [
                    "producer",
                    "processor",
                    "licensor",
                    "host"
                ],
                "url": "https://fastmap.ai"
            },
            {
                "name": "Licnesee Holder",
                "description": "Add licensee description here",
                "roles": [
                    "licensee"
                ],
                "url": "https://"
            }
        ]
    }

    let item_properties = {
        "description": "{platform} {constellation} {collectionID} captured by {Producer} and licensed by {Licensor}",
        "created": "2024-05-21T20:17:57.150260",
        "updated": "2024-05-21T20:17:57.150260",
        "constellation": "aerial",
        "eo_bands": 4,
        "eo_no_data": "alpha",
        "prj_centroid": [
            -100.0582134139518,
            51.158650916715736
        ],
        "unit": "meter",
        "compression": "deflate",
        "data_type": "uint8",
        "file_data_type": "tiff",
        "file_bits_per_sample": 8,
        "geometric_accuracy_description": "geometric accuracy * GSD"
    }

    const sendCreateCOGAssetRequest = (values) => {
        let createCOGAsset = { ...values };
        createCOGAsset.batch_job_vcpus = createCOGAsset.batch_job_vcpus.value;
        createCOGAsset.batch_job_storage = createCOGAsset.batch_job_storage.value;
        createCOGAsset.mission_id = createCOGAsset.mission_id.value;
        createCOGAsset.processing_level = createCOGAsset.processing_level.value;
        createCOGAsset.derived_from = createCOGAsset.derived_from.value;
        createCOGAsset.elevation_model = createCOGAsset.elevation_model.value;
        createCOGAsset.vertical_crs = createCOGAsset.vertical_crs.value;
        createCOGAsset.platform = createCOGAsset.platform.value;
        createCOGAsset.processing_software = createCOGAsset.processing_software.value;
        createCOGAsset.processing_facility = createCOGAsset.processing_facility.value;
        createCOGAsset.processing_lineage = createCOGAsset.processing_lineage.value;
        createCOGAsset.collection_info = JSON.parse(createCOGAsset.collection_info);
        createCOGAsset.item_info = JSON.parse(createCOGAsset.item_info);
        createCOGAsset.item_properties = JSON.parse(createCOGAsset.item_properties);

        Swal.fire({
            title: 'Warning!',
            text: `This will start a job in the background to create the COG asset and it may take some time. Are you sure you want to continue?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.createTilesetAssets(createCOGAsset).then(() => {
                    withReactContent(Swal).fire({
                        title: "Success",
                        text: `Creating COG Asset from tiles in the directory (${createCOGAsset.tiles_directory_uri}) is started. It may take sometime!`,
                    });
                }).catch((error) => {
                    withReactContent(Swal).fire({
                        icon: 'error',
                        title: 'Error',
                        html: error.response.data?.detail,
                    });
                })
            }
        });
    }

    async function checkElevationModel(mission_id, elevation_model) {
        var promise = new Promise(function (resolve, reject) {
            AdminInterface.instance.getMission(mission_id).then((response) => {
                AdminInterface.instance.getCollection(response.data.collection_id).then((response) => {
                    if (response.data.name === 'terrain' && !['DEM Terrain Item', 'DSM Terrain Item'].includes(elevation_model)) {
                        reject()
                    } else {
                        resolve()
                    }
                })
            }).catch(() => {
                reject()
            })
        });
        return promise;
    }

    const submitNewRequest = (values) => {
        checkElevationModel(values.mission_id.value, values.elevation_model.value).then((response) => {
            sendCreateCOGAssetRequest(values)
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Invalid elevation model.',
            });
        })
    };

    const GetMissions = () => {
        AdminInterface.instance.getMissions().then((response) => {
            let missionsList = response.data.filter(mission => mission.collection.category === CollectionCategoryEnum.ortho_photo_tileset || mission.collection.category === CollectionCategoryEnum.terrain_tileset)
            .map(function (mission) {
                return { value: mission.id, label: `${mission.collection.name} ${mission.name}` }
            });

            setMissions(missionsList);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting missions.'
            });
        });
    }

    useEffect(() => {
        GetMissions();
    }, []);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Create Tileset Asset</CardTitle>
                        <CardSubhead>This form submits a request that converts tiles in a S3 directory into COGs and add them as a assets.</CardSubhead>
                    </CardTitleWrap>
                    {missions && <Form onSubmit={submitNewRequest} validate={validate} initialValues={{
                        batch_job_vcpus: { value: 8, label: '8' },
                        batch_job_storage: { value: 1, label: '1 TB' },
                        processing_level: { value: 'L1', label: 'L1' },
                        processing_lineage: { value: 'S1', label: 'S1' },
                        processing_facility: { value: 'Local', label: 'Local' },
                        processing_software: { value: "Pix4D", label: 'Pix4D' },
                        derived_from: { value: 'Frame', label: 'Frame' },
                        elevation_model: { value: undefined, label: 'None' },
                        vertical_crs: { value: undefined, label: 'None' },
                        platform: { value: 'manned', label: 'Manned' },
                        sensor_calibration: '2020Q2',
                        geometric_accuracy: 1,
                        nva_geometric_accuracy: 0,
                        vva_geometric_accuracy: 0,
                        eo_cloud_cover: 0,
                        eo_cloud_shadow: 0,
                        view_off_nadir: 0,
                        view_sun_elevation: 36,
                        collection_info: JSON.stringify(collection_info, undefined, 4),
                        item_info: JSON.stringify(item_info, undefined, 4),
                        item_properties: JSON.stringify(item_properties, undefined, 4)
                    }} >
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Virtual CPUs</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_vcpus" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobVCPUsEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Storage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="batch_job_storage" component={renderSelectField} validate={required}
                                            options={Object.entries(BatchJobStorageEnum).map(([label, value]) => ({ value, label }))} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Directory</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="tiles_directory_uri" component={FormField} placeholder="For example: s3://Toronto_SU_2018/" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Hosting Bucket</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="hosting_bucket" component={FormField} placeholder="For example: fm-tms"/>
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Mission</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="mission_id" component={renderSelectField} options={missions} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sensor Calibration</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="sensor_calibration" component={FormField} placeholder="Sensor Calibration" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Level</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_level" component={renderSelectField}
                                            options={[
                                                { value: 'RAW', label: 'RAW' },
                                                { value: 'L0', label: 'L0' },
                                                { value: 'L1', label: 'L1' },
                                                { value: 'L2', label: 'L2' },
                                                { value: 'L3', label: 'L3' },
                                                { value: 'L4', label: 'L4' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Lineage</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_lineage" component={renderSelectField}
                                            options={[
                                                { value: 'S1', label: 'S1' },
                                                { value: 'S2', label: 'S2' },
                                                { value: 'S3', label: 'S3' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Facility</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_facility" component={renderSelectField}
                                            options={[
                                                { value: 'Local', label: 'Local' },
                                                { value: 'Cloud', label: 'Cloud' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Processing Software</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="processing_software" component={renderSelectField}
                                            options={[
                                                { value: "CaptureOne", label: 'CaptureOne' },
                                                { value: "MatchAT", label: 'MatchAT' },
                                                { value: "OrthoMaster", label: 'OrthoMaster' },
                                                { value: "OrthoVista", label: 'OrthoVista' },
                                                { value: "Pix4D", label: 'Pix4D' },
                                                { value: "Agisoft", label: 'Agisoft' },
                                                { value: "FastMap Cloud", label: 'FastMap Cloud' },
                                                { value: "Proprietary", label: 'Proprietary' }
                                            ]} />

                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Derived From</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="derived_from" component={renderSelectField}
                                            options={[
                                                { value: 'Frame', label: 'Frame' },
                                                { value: 'Terrain', label: 'Terrain' },
                                                { value: 'Point Cloud', label: 'Point Cloud' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Elevation Model</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="elevation_model" component={renderSelectField}
                                            options={[
                                                { value: undefined, label: 'None' },
                                                { value: 'SRTM90', label: 'SRTM90' },
                                                { value: 'SRTM30', label: 'SRTM30' },
                                                { value: 'DEM Terrain Item', label: 'DEM Terrain Item' },
                                                { value: 'DSM Terrain Item', label: 'DSM Terrain Item' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="geometric_accuracy" component={FormField} type="number" placeholder="Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Vegetated Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="vva_geometric_accuracy" component={FormField} type="number" placeholder="Vegetated Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Non-Vegetated Geometric Accuracy</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="nva_geometric_accuracy" component={FormField} type="number" placeholder="Non-Vegetated Geometric Accuracy" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Vertical CRS</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="vertical_crs" component={renderSelectField}
                                            options={[
                                                { value: undefined, label: 'None' },
                                                { value: 'CGVD28 / HT2.0', label: 'CGVD28 / HT2.0' },
                                                { value: 'CGVD2013 / CGG2013', label: 'CGVD2013 / CGG2013' }
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Platform</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="platform" component={renderSelectField}
                                            options={[
                                                { value: 'manned', label: 'Manned' },
                                                { value: 'unmanned', label: 'Unmanned' },
                                                { value: 'CityScan', label: 'CityScan' },
                                                { value: 'StreetScan', label: 'StreetScan' },
                                                { value: 'SiteScan', label: 'SiteScan' },
                                                { value: 'Satellite', label: 'Satellite' },
                                            ]} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Cover</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_cover" component={FormField} type="number" placeholder="Cloud Cover" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Cloud Shadow</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="eo_cloud_shadow" component={FormField} type="number" placeholder="Cloud Shadow" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Off Nadir</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_off_nadir" component={FormField} type="number" placeholder="Off Nadir" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Sun Elevation</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="view_sun_elevation" component={FormField} type="number" placeholder="Sun Elevation" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Collection Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="collection_info" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Info</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_info" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Item Properties</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="item_properties" component="textarea" type="text" validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                    <Button variant="secondary" type="button" onClick={form.reset}>
                                        Cancel
                                    </Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

export default CreateTilesetAssets;
